import React from 'react';
import Paragraph from '../../paragraph';

const CheckboxDescription = ({ children, appearance = 'medium-emphasis' }) => (
  <div className="ws-ui-checkbox__description">
    <Paragraph size="small" appearance={appearance}>
      {children}
    </Paragraph>
  </div>
);

export default CheckboxDescription;
